<template>
  <div>
    <menu-content-container
      :chip="$t('forms.social_properties')"
      chip-secondary
      border-full
    >
      <content-row>
        <t-dropdown
          ref="dropdown"
          :label="$t('forms.social_style')"
          style="width: 100%"
        >
          <template #selected-content>
            <p
              v-if="styleObj"
              class="font-inter text-xs font-medium leading-[30px]"
            >
              {{ styleObj.label }}
            </p>

            <div
              v-if="styleObj"
              data-testid="selected-icon-set"
              style="
                display: flex;
                border-radius: 2px;
                padding: 2px 4px;
                gap: 4px;
              "
              :style="{ backgroundColor: styleObj.bgcolor }"
            >
              <img
                style="width: 20px; height: 20px"
                :src="`${awsFolder}/assets/social-icons/${styleObj.value}/facebook.svg`"
                alt="Facebook"
              />
              <img
                style="width: 20px; height: 20px"
                :src="`${awsFolder}/assets/social-icons/${styleObj.value}/twitter.svg`"
                alt="Twitter"
              />
              <img
                style="width: 20px; height: 20px"
                :src="`${awsFolder}/assets/social-icons/${styleObj.value}/linkedin.svg`"
                alt="LinkedIn"
              />
              <img
                style="width: 20px; height: 20px"
                :src="`${awsFolder}/assets/social-icons/${styleObj.value}/instagram.svg`"
                alt="Instagram"
              />
              <img
                style="width: 20px; height: 20px"
                :src="`${awsFolder}/assets/social-icons/${styleObj.value}/pinterest.svg`"
                alt="Pinterest"
              />
              <img
                style="width: 20px; height: 20px"
                :src="`${awsFolder}/assets/social-icons/${styleObj.value}/youtube.svg`"
                alt="YouTube"
              />
            </div>
          </template>

          <template #content>
            <ul>
              <VueCustomScrollbar
                style="height: 200px"
                :settings="{ wheelPropagation: false }"
              >
                <li
                  v-for="(iconStyle, i) in iconStyles"
                  :key="i"
                  :data-testid="'icon-set-' + iconStyle.value"
                  style="
                    padding: 4px 0;
                    display: flex;
                    justify-content: flex-start;
                  "
                  @click="setStyle(iconStyle.value)"
                >
                  <p
                    v-if="iconStyle"
                    style="width: 120px; padding-left: 12px"
                    class="font-inter text-xs font-medium leading-[28px]"
                  >
                    {{ iconStyle.label }}
                  </p>
                  <div
                    v-if="iconStyle"
                    style="
                      display: flex;
                      border-radius: 2px;
                      padding: 2px 4px;
                      gap: 4px;
                    "
                    :style="{ backgroundColor: iconStyle.bgcolor }"
                  >
                    <img
                      style="width: 20px; height: 20px"
                      :src="`${awsFolder}/assets/social-icons/${iconStyle.value}/facebook.svg`"
                      alt="Facebook"
                    />
                    <img
                      style="width: 20px; height: 20px"
                      :src="`${awsFolder}/assets/social-icons/${iconStyle.value}/twitter.svg`"
                      alt="Twitter"
                    />
                    <img
                      style="width: 20px; height: 20px"
                      :src="`${awsFolder}/assets/social-icons/${iconStyle.value}/linkedin.svg`"
                      alt="LinkedIn"
                    />
                    <img
                      style="width: 20px; height: 20px"
                      :src="`${awsFolder}/assets/social-icons/${iconStyle.value}/instagram.svg`"
                      alt="Instagram"
                    />
                    <img
                      style="width: 20px; height: 20px"
                      :src="`${awsFolder}/assets/social-icons/${iconStyle.value}/pinterest.svg`"
                      alt="Pinterest"
                    />
                    <img
                      style="width: 20px; height: 20px"
                      :src="`${awsFolder}/assets/social-icons/${iconStyle.value}/youtube.svg`"
                      alt="YouTube"
                    />
                  </div>
                </li>
              </VueCustomScrollbar>
            </ul>
          </template>
        </t-dropdown>
      </content-row>

      <content-row>
        <t-input-number
          v-model="iconSize.model"
          data-testid="icon-size"
          unit=""
          :label="$t('forms.social_size')"
          :changed="iconSize.changed"
          :reset-tooltip="$t('forms.reset_value')"
          @reset="iconSize.reset"
        ></t-input-number>
        <t-input-number
          v-model="iconPadding.model"
          data-testid="icon-padding"
          unit=""
          :label="$t('forms.padding_label')"
          :changed="iconPadding.changed"
          :reset-tooltip="$t('forms.reset_value')"
          @reset="iconPadding.reset"
        ></t-input-number>
      </content-row>
    </menu-content-container>

    <menu-content-container
      :header="$t('forms.social_settings')"
      :border-bottom="false"
    >
      <t-note>{{ $t("forms.social_settings_note") }}</t-note>
    </menu-content-container>
    <menu-content-container border-full :padding-left-right="8">
      <social-networks :selected-style="styleObj"></social-networks>
    </menu-content-container>

    <menu-content-container border-full :padding-left-right="8">
      <TLabel
        :changed="align.changed"
        :tooltip="$t('forms.reset_value')"
        data-testid="align-label"
        @reset="align.reset"
        >{{ $t("forms.button_align") }}</TLabel
      >
      <content-row :margin-top="4">
        <TButtonGroup>
          <TGroupButton
            data="left"
            data-testid="align-left"
            medium
            :active="align.model === 'left'"
            @button-clicked="align.model = 'left'"
          >
            <AligmentLeft />
          </TGroupButton>
          <TGroupButton
            data="center"
            data-testid="align-center"
            medium
            :active="align.model === 'center'"
            @button-clicked="align.model = 'center'"
          >
            <AligmentCenter />
          </TGroupButton>
          <TGroupButton
            data="right"
            data-testid="align-right"
            medium
            :active="align.model === 'right'"
            @button-clicked="align.model = 'right'"
          >
            <AligmentRight />
          </TGroupButton>
        </TButtonGroup>
      </content-row>
    </menu-content-container>

    <padding-form
      data-testid="social-margin"
      :label="$t('forms.social_margin')"
      :changed="padding.changed"
      :default-value="padding.defaultValue"
      :reset-tooltip="$t('forms.reset_value')"
      @reset="padding.reset"
    ></padding-form>

    <menu-content-container :border-bottom="false">
      <content-row>
        <hide-on-mobile></hide-on-mobile>
      </content-row>
      <content-row :margin-bottom="20" :margin-top="16">
        <hide-on-desktop></hide-on-desktop>
      </content-row>
    </menu-content-container>
  </div>
</template>

<script lang="ts" setup>
  import paddingForm from "./paddingForm.vue";
  import hideOnMobile from "./components/hideOnMobile.vue";
  import hideOnDesktop from "./components/hideOnDesktop.vue";
  import SocialNetworks from "@/forms/components/SocialNetworks/SocialNetworks.vue";
  import { useMjmlStore } from "@/stores/mjmlStore";
  import { useBlockAttr } from "@/composables/useBlockAttr";
  import { TopolSocialBlock } from "@/schemas/template/blocks/socialBlockSchema";

  import { AligmentLeft, AligmentCenter, AligmentRight } from "@topol/icons";
  import {
    TInputNumber,
    TButtonGroup,
    TGroupButton,
    TDropdown,
    TNote,
    TLabel,
  } from "@topol/twig-ui";

  import { PerfectScrollbar as VueCustomScrollbar } from "vue3-perfect-scrollbar";
  import { ref, computed, onMounted } from "vue";

  const dropdown = ref();
  const iconStyles = [
    {
      value: "rounded",
      label: "Rounded",
    },
    {
      value: "ikony-black/roundedblack",
      label: "Rounded black",
      bgcolor: "#CBCBCD",
    },
    {
      value: "roundedwhite",
      label: "Rounded white",
    },
    {
      value: "outlined",
      label: "Outlined",
    },
    {
      value: "ikony-black/outlinedblack",
      label: "Outlined black",
      bgcolor: "#CBCBCD",
    },
    {
      value: "outlinedbw",
      label: "Outlined Grey",
    },
    {
      value: "squared",
      label: "Squared",
    },
    {
      value: "ikony-black/squaredblack",
      label: "Squared Black",
      bgcolor: "#CBCBCD",
    },
    {
      value: "simple",
      label: "Simple",
    },
    {
      value: "ikony-black/simpleblack",
      label: "Simple black",
      bgcolor: "#CBCBCD",
    },
    {
      value: "simplegrey",
      label: "Simple grey",
    },
    {
      value: "simplewhite",
      label: "Simple white",
    },
  ];
  const availableNetworks = ref([
    "Facebook",
    "Twitter",
    "LinkedIn",
    "Instagram",
    "Pinterest",
    "YouTube",
  ]);

  const mjmlStore = useMjmlStore();
  const { px, str, nullable } = useBlockAttr({ mode: "active" });

  // --- Composable bindings ---
  const iconSize = px("icon-size", 20);
  const iconPadding = px("icon-padding", 0);
  const align = str("align");
  const padding = nullable("padding");

  const style = computed(() => {
    if (activeBlock.value) {
      if (activeBlock.value.style) {
        return activeBlock.value.style;
      } else if (activeBlock.value.children && activeBlock.value.children[0]) {
        let src = "";

        for (const child of activeBlock.value.children) {
          if (child && !child.attributes.name.includes("custom")) {
            src = child.attributes.src;
            break;
          }
        }

        if (src === "") {
          return "outlined";
        }

        const parts = src.split("/");

        //bacuse the url of black icons changed we need to check if the URL is for the black version
        if (parts.length > 8) {
          return parts[6] + "/" + parts[7];
        }

        if (parts[6]) {
          return parts[6];
        }
      }
    }

    return "outlined";
  });

  const styleObj = computed(() => {
    const defaultStyle = {
      value: "outlined",
      label: "Outlined",
    };

    const index = iconStyles.findIndex(
      (styleItem) => styleItem.value === style.value
    );

    return iconStyles[index] || defaultStyle;
  });

  const activeBlock = computed(() => {
    const actBlock = mjmlStore.getActiveBlock as TopolSocialBlock | undefined;
    if (actBlock && actBlock.children) {
      const filterdChildren = actBlock.children.filter(
        (child) =>
          typeof child === "object" && typeof child.attributes === "object"
      );
      if (actBlock.children.length !== filterdChildren.length)
        actBlock.children = filterdChildren;
    }
    return actBlock;
  });

  const awsFolder = computed(() => {
    return import.meta.env.VITE_APP_AWS_FOLDER;
  });

  function setStyle(val: string) {
    if (!activeBlock.value) {
      return;
    }
    dropdown.value.opened = false;

    const socialElements = activeBlock.value.children || [];
    for (let i = 0; i < socialElements.length; i++) {
      if (
        socialElements[i].attributes["name"] &&
        socialElements[i].attributes["name"].split("-")[0] !== "custom"
      ) {
        mjmlStore.updateBlockChildrenAttribute({
          childIndex: i,
          prop: "src",
          value:
            "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/" +
            val +
            "/" +
            socialElements[i].attributes["name"]
              .toLowerCase()
              .replace("-noshare", "") +
            ".png",
        });
      }
    }
    mjmlStore.updateBlockProp({
      prop: "style",
      value: val,
    });
  }

  onMounted(() => {
    if (activeBlock.value && activeBlock.value.children) {
      activeBlock.value.children.forEach((block: any) => {
        availableNetworks.value = availableNetworks.value.filter(
          (n) => n !== block.attributes.name.toLowerCase()
        );
      });
    }
  });
</script>
